export default __webpack_public_path__ + "static/media/usdt.2c1060db.svg";